import WidgetNumericBlock from 'components/Banners/WidgetNumericBlock';
import React from 'react';
import { WidgetNumericBlockModel } from 'types/fragments';

export const GetWidgetNumericBlockElement = (
	bannerData: WidgetNumericBlockModel
) => {
	return <WidgetNumericBlock {...bannerData}></WidgetNumericBlock>;
};
